import React from 'react';

const DeletedCampaignSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="30" height="30">
    <defs>
      <linearGradient id="paperGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#bdbdbd" />
        <stop offset="100%" stopColor="#9e9e9e" />
      </linearGradient>
      <linearGradient id="xGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ef4444" />
        <stop offset="100%" stopColor="#dc2626" />
      </linearGradient>
    </defs>

    {/* Background circle */}
    <circle cx="32" cy="32" r="28" fill="#f5f5f5" stroke="#d4d4d4" strokeWidth="2" />

    {/* Paper/Document Shape */}
    <rect
      x="18"
      y="14"
      width="28"
      height="36"
      rx="3"
      ry="3"
      fill="url(#paperGrad)"
      stroke="#9e9e9e"
      strokeWidth="1.5"
      opacity="0.8"
    />

    {/* Folded corner */}
    <path d="M38 14 L46 22 L38 22 Z" fill="#e0e0e0" />

    {/* Lines representing campaign text */}
    <g stroke="#757575" strokeWidth="1.5" opacity="0.5">
      <line x1="22" y1="26" x2="42" y2="26" />
      <line x1="22" y1="31" x2="42" y2="31" />
      <line x1="22" y1="36" x2="38" y2="36" />
    </g>

    {/* Red X (Deleted mark) */}
    <g>
      <line x1="22" y1="42" x2="42" y2="52" stroke="url(#xGrad)" strokeWidth="4" strokeLinecap="round" />
      <line x1="42" y1="42" x2="22" y2="52" stroke="url(#xGrad)" strokeWidth="4" strokeLinecap="round" />
      {/* Soft white overlay for contrast */}
      <line x1="22" y1="42" x2="42" y2="52" stroke="white" strokeWidth="6" opacity="0.3" strokeLinecap="round" />
      <line x1="42" y1="42" x2="22" y2="52" stroke="white" strokeWidth="6" opacity="0.3" strokeLinecap="round" />
    </g>

    {/* Red outer highlight */}
    <circle cx="32" cy="32" r="28" fill="none" stroke="#ef4444" strokeWidth="2" opacity="0.5" />

    {/* Small deletion indicator badge (trash icon hint) */}
    <rect x="46" y="12" width="10" height="10" rx="2" fill="#ef4444" stroke="#dc2626" strokeWidth="1.5" />
    <g stroke="white" strokeWidth="2" strokeLinecap="round">
      <line x1="48" y1="14" x2="54" y2="20" />
      <line x1="54" y1="14" x2="48" y2="20" />
    </g>
  </svg>
);

export default DeletedCampaignSvg;
